/**
 * Should this Enter keypress be stopped from implicitly submitting the form?
 *
 * antd's `<Form onFinish>` submits on Enter from any single-line input. On a
 * document-creating form that means an operator tabbing through fields can
 * create the record mid-configuration — live QA created a WZ this way from the
 * "Numer faktury sprzedaży" field, and the same keypress in the PZ receipt-date
 * picker fired a submit that only validation happened to stop.
 *
 * Single home for the rule, wired as a form-level `onKeyDown` (see
 * SharedTransportForm, WZNew, PZDetail):
 *  - `<textarea>` keeps Enter, because a newline is the whole point of a notes
 *    field;
 *  - a real `<button>` keeps Enter, so focusing "Zapisz" and pressing Enter
 *    still saves — the deliberate submit path stays intact;
 *  - everything else (inputs, antd's InputNumber/DatePicker/Select inner
 *    inputs) is prevented. `preventDefault` only cancels the browser's implicit
 *    submit; component keydown handlers, such as rc-select choosing the
 *    highlighted option, have already run and still work.
 */
export function shouldPreventEnterFormSubmit(event: {
  key: string;
  target: EventTarget | null;
}): boolean {
  if (event.key !== 'Enter') {
    return false;
  }

  const target = event.target as HTMLElement | null;
  const tagName = target?.tagName;

  if (tagName === 'TEXTAREA') {
    return false;
  }

  if (tagName === 'BUTTON') {
    return false;
  }

  return true;
}
